<template>
    <v-card flat>
        <v-card-text>
            <v-container center>
                <v-row v-if="selectedItem.length == 0">
                    <v-col cols="12" sm="12" md="12">
                        <v-spacer class="text-center">
                        Não há telefones cadastrados para este usuário
                        </v-spacer>
                    </v-col>
                </v-row>
                <v-row v-else v-for="phone in selectedItem" :key="phone.id">
                    <v-col cols="9" sm="9" md="9">
                        <v-text-field
                            :value="phone.phone_number"
                            label="Número"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3" sm="3" md="3">
                         <v-checkbox
                            v-model="phone.is_main_phone"
                            label="Telefone Principal"
                            readonly
                            hide-details="auto"
                        ></v-checkbox>
                    </v-col>
                </v-row>   
            </v-container>
        </v-card-text>
    </v-card>
</template>


<script>
export default {
  name: 'Phones',
  props: {
    selectedItem: {
        type: Array,
        required: true,
    },
  },
}
</script>
